import React, { useState } from 'react'
import Carousel from 'react-elastic-carousel'
import { Arrow, Balance, MoneySvg, TrendSvg } from 'src/assets'
import { HomeQuickSaveBtn } from 'src/components/Global/Button/Button'
import { HomePageCard } from 'src/components/Global/Cards/Cards'
import useUserData from 'src/hooks/useUserData'
import { HomeWelcomeWrapper, UserTask } from './homeWelcomeStyle'
import { breakPoints } from './sliderBreakPoints'
import { Link, useLocation } from 'react-router-dom'
import { verifyEmail, LinkBvn, Biodata } from 'src/assets'
import { verifyAccountAction } from 'src/redux/actions/auth'
import { useDispatch } from 'react-redux'
import useSnackbar from 'src/hooks/useSnackBar'

interface IData {
  id: string
  Amount: any
  Description: string
  icon: any
  ArrowIcon: any
  className?: string
}
const HomeWelcome = () => {
  const data = useUserData()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const Clicked = localStorage.getItem('PREFERENCE')!
  const HomepageData: IData[] = [
    {
      id: '1',
      Amount:
        Clicked === 'true' ? '****' : data.user.accounts.available_balance,
      Description: 'Available Balance',
      icon: Balance,
      ArrowIcon: Arrow,
      className: 'balance_card',
    },
    {
      id: '2',
      Amount: Clicked === 'true' ? '****' : data.user.accounts.total_interest,
      Description: 'Interest',
      icon: TrendSvg,
      ArrowIcon: Arrow,
      className: 'money_interest_card last_child',
    },
    {
      id: '3',
      Amount: Clicked === 'true' ? '****' : data.user.accounts.total_investment,
      Description: 'Investment',
      icon: MoneySvg,
      ArrowIcon: Arrow,
      className: 'money_interest_card',
    },
    {
      id: '4',
      Amount: Clicked === 'true' ? '****' : data.user.accounts.total_withdrawal,
      Description: 'Total Withdrawal',
      icon: TrendSvg,
      ArrowIcon: Arrow,
      className: 'money_interest_card last_child',
    },
  ]
  const snackbar = useSnackbar()

  const location = useLocation()
  const verify = (e: any) => {
    e.preventDefault()
    setLoading(true)
    dispatch(verifyAccountAction({ onSuccess, onError }))
  }

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Error verifying your account',
      severity: 'error',
    })
  }
  return (
    <HomeWelcomeWrapper>
      <div className="welcome_save_wrapper">
        <div className="welcome_text">
          <h1>
            Hi <span>{data.user.first_name}</span>
          </h1>
          <p>How are you doing today?</p>
        </div>
        <div className="call_to_action_btn">
          <Link
            to={`/quicksave-amount`}
            state={{ backgroundLocation: location }}
          >
            <HomeQuickSaveBtn>Quick Save</HomeQuickSaveBtn>
          </Link>
        </div>
      </div>
      <UserTask>
        {!data.user.kyc.bvn_verified && (
          <Link
            to={'/bank-setting'}
            state={{ backgroundLocation: location }}
            className="new-cards"
          >
            <div className="flex-center">
              <img src={LinkBvn} alt="" />
              <p>Add Bank</p>
            </div>
          </Link>
        )}
        {!data.user.kyc.account_verified && (
          <Link
            to={''}
            state={{ backgroundLocation: location }}
            className="new-cards"
            onClick={verify}
          >
            <div className="flex-center">
              <img src={verifyEmail} alt="" />
              {!loading && <p>Verify Email</p>}
              {loading && <p>verifying...</p>}
              {}
            </div>
          </Link>
        )}
        {!data.user.has_withdrawal_pin && (
          <Link
            to={'/create-pin'}
            state={{ backgroundLocation: location }}
            className="new-cards"
          >
            <div className="flex-center">
              <img src={Biodata} alt="" />
              <p>Create pin</p>
            </div>
          </Link>
        )}
      </UserTask>
      <div className="contain-card lg">
        {HomepageData.map((item) => (
          <HomePageCard key={item.id} className={item.className}>
            <div className="wrap_flex">
              <div className="icon">
                <img src={item.icon} alt="" className="icon" />
              </div>
              <div className="description_amount_wrapper">
                <p className="description_text">{item.Description}</p>
                <p className="amount">{item.Amount}</p>
              </div>
            </div>
          </HomePageCard>
        ))}
      </div>
      <div className="mb">
        <Carousel
          isRTL={false}
          breakPoints={breakPoints}
          className="slider"
          showArrows={false}
          enableMouseSwipe={true}
          outerSpacing={0}
          itemPadding={[0, 0]}
        >
          {HomepageData.map((item) => (
            <HomePageCard key={item.id} className={item.className}>
              <div className="wrap_flex">
                <div className="icon">
                  <img src={item.icon} alt="" className="icon" />
                </div>
                <div className="description_amount_wrapper">
                  <p className="description_text">{item.Description}</p>
                  <p className="amount">{item.Amount}</p>
                </div>
              </div>
            </HomePageCard>
          ))}
        </Carousel>
      </div>
    </HomeWelcomeWrapper>
  )
}

export { HomeWelcome }
